import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
const explorationSteps = ['Review the clinical pathways.', 'Explore the decision algorithms.', 'Use the consultation tools.', 'Go through the clinical cases.'];
export function Guarantee() {
  return <section className="w-full bg-navy-900 py-14 sm:py-20" data-id="element-157" data-mp="29e6nlk3fxj24">
      <div className="mx-auto w-full max-w-3xl px-5" data-id="element-158" data-mp="29frkvhh53g3o">
        <div className="rounded-3xl border border-emerald-500/30 bg-emerald-500/5 p-5 sm:p-8" data-id="element-159" data-mp="2ec86o50v9idl">
          <div className="flex items-center gap-3" data-id="element-160" data-mp="2jb1no7fd3rii">
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-emerald-500" data-id="element-161" data-mp="2ob7ifwgxhu4t">
              <ShieldCheckIcon className="h-6 w-6 text-white" aria-hidden="true" data-id="element-162" data-mp="2scizvepnf91x" />
            </span>
            <h2 className="font-display text-xl font-extrabold uppercase leading-tight tracking-tight text-white sm:text-2xl" data-id="element-163" data-mp="tyr38665n5nt">
              7-Day Satisfaction Guarantee
            </h2>
          </div>

          <p className="mt-5 text-[1rem] font-semibold text-emerald-300" data-id="element-164" data-mp="3smzox48cthz4">
            Explore the system before making your final decision.
          </p>

          <ul className="mt-4 space-y-2" data-id="element-165" data-mp="3iv3rlve3dvvy">
            {explorationSteps.map(step => <li key={step} className="rounded-xl bg-white/5 px-4 py-2.5 text-[0.92rem] text-slate-200" data-id="element-166" data-mp="3dwsgzifz3hco">
                {step}
              </li>)}
          </ul>

          <p className="mt-5 text-[0.95rem] leading-relaxed text-slate-300" data-id="element-167" data-mp="afjzizp5qjih">
            If within the first 7 days you decide that Clinical Route for
            Erectile Dysfunction™ isn’t useful for helping you structure your
            consultations, simply contact us. We’ll refund your purchase
            according to the guarantee terms.
          </p>

          <div className="mt-5 flex flex-wrap gap-2" data-id="element-168" data-mp="2l7uz3gfobmkg">
            {['No complicated process', 'No unnecessary explanations', 'No risk'].map(item => <span key={item} className="rounded-full border border-white/15 bg-white/5 px-3 py-1.5 text-[0.75rem] font-semibold text-slate-200" data-id="element-169" data-mp="1h9r9vsaxhns3">
                {item}
              </span>)}
          </div>
        </div>

        <div className="mx-auto mt-10 max-w-md" data-id="element-170" data-mp="18b5xkew1v4zr">
          <CTAButton label="I want to try it risk-free" note="7-day satisfaction guarantee" data-id="element-171" data-mp="tjdpmnyl4t82" />
        </div>
      </div>
    </section>;
}